import React, { useState } from "react"
import Dialog from "./Dialog"

const Letter = props => {
  const [showDialog, setShowDialog] = useState(false)
  const [currentLetter, setCurrentLetter] = useState()
    const pinned = props.pinned;
  const showDialogFlag = () => {
    setShowDialog(true)
    setCurrentLetter(props.letter)
  }

  const onCloseDialog = () => {
    setShowDialog(false)
  }
  const handleComment = (comment) => {
    setCurrentLetter({
        ...currentLetter,
        commentsArray: currentLetter.commentsArray ? [...currentLetter.commentsArray , comment]: [comment]
    })
  }
//   console.log("props", props.letter)

  return props.letter ? (
    <>
      <div
        className={` letter-box-container text-center cursor-pointer ${props.letter.tags.includes("pin") ? 'border-dred bg-black ': 'border-white'} ${props.letter.tags.includes("dream") ? 'border-lblue bg-dblue ': 'border-white'}`}
        onClick={showDialogFlag}
      >
        <div className="">
          <span>
            {new Date(props.letter.originalDate).toLocaleDateString()}
          </span>{" "}
          <h4>
            {" "}
            {props.letter.header.substring(
              0,
              Math.min(props.letter.header.length, 30)
            )}{" "}
            ...
          </h4>
        </div>
        <p className="text-overflow p-1x ">{props.letter.body}</p>
      </div>

      <Dialog
        isOpen={showDialog}
        onClose={onCloseDialog}
        letterContent={currentLetter}
        onComment={handleComment}
      >
        <h2>header</h2>
      </Dialog>
    </>
  ) : (
    <></>
  )
}

export default Letter
